let preloadPromise: Promise<void> | null = null;

export function splinePreload (
  url: string
): Promise<void> {

  if (typeof window === 'undefined') {
    return Promise.resolve();
  }

  if (!preloadPromise) {
    preloadPromise = fetch(url, {
      cache: 'force-cache',
      priority: 'high'
    }).then(() => undefined);
  }

  return preloadPromise;
}

export function getSplinePreloadPromise() {
  return preloadPromise;
}